import React from 'react';
import './Logo.css';
import logo from '../assets/logo.png';

const Logo = () => {
  return (
    <div className="logo-container">
      <img src={logo} alt="Company Logo" className="logo-image" />
    </div>
  );
};

export default Logo;
